import React, { FC, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { HeaderStyle } from "./styles";
import logo from '../../assets/logo.svg';
import { Link } from "react-router-dom";
import {
  Button,
  Menu,
  MenuItem,
  Box,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
//import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import '../../styles/App.css';

const Header: FC = () => {
    const { t, i18n } = useTranslation();

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
    const [deferredPrompt, setDeferredPrompt] = useState<any>(null)
    const [contactOpen, setContactOpen] = useState(false);

    useEffect(() => {
      const handleBeforeInstallPrompt = (e: Event) => {
        e.preventDefault();
        setDeferredPrompt(e);
      };

      window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

      return () => {
        window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
      };
    }, []);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
      setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
      setAnchorEl(null)
    }

    const handleInstallClick = async () => {
      if (deferredPrompt) {
        deferredPrompt.prompt();
        const { outcome } = await deferredPrompt.userChoice;
        if (outcome === 'accepted') {
          setDeferredPrompt(null);
        }
      }
      handleClose();
    };

    return(
      <header style={HeaderStyle.header}>
      <img src={logo} alt={"Logo"} width={108.09} height={37} />
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Typography variant="caption" sx={{ color: 'orange', fontWeight: 'bold' }}>
            {t('header.fullOffline')}
          </Typography>
          <Button
            variant="outlined"
            onClick={() => i18n.changeLanguage(i18n.language === 'pt' ? 'en' : 'pt')}
            sx={{
              color: 'white',
              borderColor: 'white',
              minWidth: '40px',
              padding: '4px 8px',
              '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.1)', borderColor: 'white' }
            }}
          >
            {i18n.language === 'pt' ? 'EN' : 'PT'}
          </Button>

          {deferredPrompt && (
            <Button variant="contained" onClick={handleInstallClick} sx={{ backgroundColor: 'white', color: '#7BA238', fontWeight: 'bold', '&:hover': { backgroundColor: '#f0f0f0' } }}>
              {t('header.installApp')}
            </Button>
          )}
        <Button variant="outlined" onClick={handleClick}  sx={{
            color: 'white',
            borderColor: 'white',
            '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.1)', borderColor: 'white', },}}>
          {t('header.menu')}
        </Button>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          <MenuItem component={Link} to="/" onClick={handleClose}>
            {t('header.credentials')}
          </MenuItem>
          <MenuItem component={Link} to="/create" onClick={handleClose}>
            {t('header.createToken')}
          </MenuItem>
          <MenuItem component={Link} to="/update" onClick={handleClose}>
            {t('header.updateToken')}
          </MenuItem>
          <MenuItem component={Link} to="/viewtoken" onClick={handleClose}>
            {t('header.viewToken')}
          </MenuItem>
          <MenuItem component={Link} to="/finish" onClick={handleClose}>
            {t('header.finishToken')}
          </MenuItem>
          <MenuItem component={Link} to="/assets" onClick={handleClose}>
            {t('header.assets')}
          </MenuItem>
          <MenuItem component={Link} to="/wallet" onClick={handleClose}>
            {t('header.wallet')}
          </MenuItem>
          <MenuItem component={Link} to="/register-ip" onClick={handleClose}>
            {t('header.registerIP')}
          </MenuItem>
          <MenuItem onClick={() => { handleClose(); setContactOpen(true); }}>
            {t('header.contact')}
          </MenuItem>
          <MenuItem   component="a" 
                      href="https://arpt.com.br/" 
                      onClick={handleClose}>
            {t('header.manejoARPT')}
          </MenuItem>
        </Menu>

        <Dialog open={contactOpen} onClose={() => setContactOpen(false)}>
          <DialogTitle>{t('header.contact')}</DialogTitle>
          <DialogContent>
            <Typography variant="body1" gutterBottom>
              {t('header.contactEmail')}
            </Typography>
            <Typography variant="body1">
              {t('header.contactWhatsApp')}
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setContactOpen(false)}>Close</Button>
          </DialogActions>
        </Dialog>

        </Box>
      </header>  

    );

  /*  
    return (
        <header style={HeaderStyle.header}>
          <img src={logo} alt={"Logo"} width={108.09} height={37} />
          <Box>
            <nav className="navbar">
              <div className="dropdown">
                <button className="button" 
                    onClick={() => {setShowSendDropdown(false); setShowHomeDropdown(!showHomeDropdown); 
                                    setShowTodoDropdown(false);}}>
                  Início
                </button>
                {showHomeDropdown && (
                  <div className="dropdown-content">

                    <button className="dropdown-button" onClick={() => handlePageChange('home')}>
                      Acessar
                    </button>

                    <button className="dropdown-button" onClick={() => handlePageChange('HomeARPT')}>
                      Início
                    </button>


                  </div>
                )}
              </div>

              <div className="dropdown">
                <button className="button" 
                    onClick={() => {setShowSendDropdown(false); setShowTodoDropdown(!showTodoDropdown); 
                                    setShowHomeDropdown(false); setShowDTDDropdown(false);}}>
                  Ferramentas
                </button>
                {showTodoDropdown && (
                  <div className="dropdown-content">

                      <button className="dropdown-button" 
                          onClick={() => {setShowSendDropdown(!showSendDropdown); setShowDTDDropdown(false); setShowDataDropdown(false)
                          }}>
                        Send Satoshis
                      </button>
                      {showSendDropdown && (
                        <div className="button">
                          <button className="dropdown-button-right" style={{ border: '1px solid #fff', marginLeft: 'auto',  marginRight: '0', 
                          fontSize: '12px',color: 'white', background: '#323a3c', width: '60%'}} onClick={() => handlePageChange('home02')}>
                            p2pkh-p2pkh
                          </button>

                        </div>
                      )}

                      <button className="dropdown-button" 
                          onClick={() => {setShowDTDDropdown(!showDTDDropdown); setShowSendDropdown(false); 
                          setShowDataDropdown(false)}}>
                        Track Token
                      </button>
                      {showDTDDropdown && (
                        <div className="button">

                          <button className="dropdown-button-right" style={{ border: '1px solid #fff', marginLeft: 'auto',  marginRight: '0', 
                          fontSize: '12px',color: 'white', background: '#323a3c', width: '60%'}} onClick={() => handlePageChange('home13')}>
                            Create
                          </button>
                          <button className="dropdown-button-right" style={{ border: '1px solid #fff', marginLeft: 'auto',  marginRight: '0', 
                          fontSize: '12px',color: 'white', background: '#323a3c', width: '60%'}} onClick={() => handlePageChange('home13b')}>
                            Create-Encrypt
                          </button>
                          <button className="dropdown-button-right" style={{ border: '1px solid #fff', marginLeft: 'auto', marginRight: '0', 
                          fontSize: '12px',color: 'white', background: '#323a3c', width: '60%'}} onClick={() => handlePageChange('home04')}>
                            Read
                          </button>
                          <button className="dropdown-button-right" style={{ border: '1px solid #fff', marginLeft: 'auto', marginRight: '0', 
                          fontSize: '12px',color: 'white', background: '#323a3c', width: '60%'}} onClick={() => handlePageChange('home04dec')}>
                            Read-Decrypt
                          </button>
                          <button className="dropdown-button-right" style={{ border: '1px solid #fff', marginLeft: 'auto', marginRight: '0', 
                          fontSize: '12px',color: 'white', background: '#323a3c', width: '60%'}} onClick={() => handlePageChange('home14')}>
                            Update
                          </button>
                          <button className="dropdown-button-right" style={{ border: '1px solid #fff', marginLeft: 'auto', marginRight: '0', 
                          fontSize: '12px',color: 'white', background: '#323a3c', width: '60%'}} onClick={() => handlePageChange('home14b')}>
                            Update-Encrypt
                          </button>
                          <button className="dropdown-button-right" style={{ border: '1px solid #fff', marginLeft: 'auto', marginRight: '0', 
                          fontSize: '12px',color: 'white', background: '#323a3c', width: '60%'}} onClick={() => handlePageChange('home15')}>
                            Transfer
                          </button>
                          <button className="dropdown-button-right" style={{ border: '1px solid #fff', marginLeft: 'auto', marginRight: '0', 
                          fontSize: '12px',color: 'white', background: '#323a3c', width: '60%'}} onClick={() => handlePageChange('home15b')}>
                            Transfer-Encrypt
                          </button>
                          <button className="dropdown-button-right" style={{ border: '1px solid #fff', marginLeft: 'auto', marginRight: '0', 
                          fontSize: '12px',color: 'white', background: '#323a3c', width: '60%'}} onClick={() => handlePageChange('home16')}>
                            Melt
                          </button>

                          <button className="dropdown-button-right" style={{ border: '1px solid #fff', marginLeft: 'auto', marginRight: '0', 
                          fontSize: '12px',color: 'white', background: '#323a3c', width: '60%'}} onClick={() => handlePageChange('home17')}>
                            DataEnc
                          </button>
                          
                        </div>
                      )}
                    
                  </div>
                )}
              </div>
            </nav>
          </Box>
        </header>
    );

    */
};

export default Header;